import { PRESETS, presetStartingPrice, presetServiceNames } from '../../lib/proposalPresets'
import { money } from '../../lib/priceList'

/**
 * The packages a proposal can start from, as cards: what it is, which
 * services are in it, and what it comes to on the list before any combined
 * credit. Used by the new-proposal dialog and by an empty proposal in the
 * studio, so the two never offer different lineups.
 *
 * A package whose services have all left the list is not offered; one missing
 * a service still is, and says so when picked.
 */

const GROUPS = [['package', 'Packages'], ['retainer', 'Retainers']]

const groupLabel = { fontFamily: 'var(--fu)', fontSize: 10, fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--mut)', marginBottom: 8 }

export function priceLine(preset, services) {
  const { once, monthly } = presetStartingPrice(preset, services)
  if (once > 0 && monthly > 0) return `from ${money(once)} + ${money(monthly)}/mo`
  if (once > 0) return `from ${money(once)}`
  if (monthly > 0) return `${money(monthly)}/mo`
  return ''
}

export default function PackageCards({ services = [], value = '', onPick, name = 'np-package' }) {
  const offered = PRESETS.filter(p => presetServiceNames(p, services).length > 0)
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {GROUPS.map(([key, title]) => {
        const list = offered.filter(p => p.group === key)
        if (!list.length) return null
        return (
          <div key={key} role="radiogroup" aria-label={title}>
            <div style={groupLabel}>{title}</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 10 }}>
              {list.map(p => {
                const checked = value === p.id
                return (
                  <label key={p.id} style={{
                    display: 'flex', flexDirection: 'column', gap: 5, padding: '12px 14px', cursor: 'pointer', borderRadius: 10,
                    border: checked ? '2px solid var(--navy)' : '1px solid var(--bdr2)', margin: checked ? 0 : 1,
                    background: 'var(--card)', fontFamily: 'var(--fu)',
                  }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <input type="radio" name={name} value={p.id} checked={checked} onChange={() => onPick?.(p)}
                        style={{ margin: 0, accentColor: 'var(--accent)' }} />
                      <span style={{ fontSize: 14, fontWeight: 800, color: 'var(--navy)' }}>{p.name}</span>
                    </span>
                    <span style={{ fontSize: 12.5, lineHeight: 1.45, color: 'var(--mut)' }}>{p.tagline}</span>
                    <span style={{ fontSize: 11.5, lineHeight: 1.45, color: 'var(--hint)' }}>{presetServiceNames(p, services).join(' · ')}</span>
                    <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--txt)', marginTop: 2 }}>{priceLine(p, services)}</span>
                  </label>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}
